export const PUDDING_BOT_FLAG = "pudding_bot";

export const CHAT_ENDPOINT =
  "https://tkvgbi36y642dmjtjypyqs6tgu0gjmof.lambda-url.eu-west-2.on.aws/chat";
